import React, { useState, useEffect, useRef } from "react";
import HeaderLeft from "./HeaderLeft";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import { Formik, ErrorMessage } from "formik";
import * as Yup from "yup";
import DropdownRight from "./DropdownRight";
import http from "../services/http";
import GetStorage from "../services/Storage";
import { ToastContainer } from "react-toastify";
import { showToast } from "./ShowToast";
import edit from "../assets/images/edite.png";
import users from "../assets/images/user.png";
import upload from "../assets/images/upload.png";
import storage from "../services/Storage";
import { SpinnerCircular } from "spinners-react";
import Select from "react-select"; // Import react-select


function EditProfile(props) {
  const token = GetStorage.get("xAuthToken");
  let user = localStorage.getItem("user");
  user = JSON.parse(user);

  const [error, setError] = useState("");
  // const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [analystinfo, setAnalystinfo] = useState({});
  const [uploadSpin, setUploadSpin] = useState(false);
  const [uploadSpins, setUploadSpins] = useState(false);
  const [bankOptions, setBankOptions] = useState([]);
  const [selectedBank, setSelectedBank] = useState(null);

  // const handleChangess = (event) => {
  //   setFirstname(event.target.value);
  // };
  const handleChangesss = (event) => {
    setLastname(event.target.value);
  };
  const analyistInfo = async () => {
    console.log("personal info");
    setUploadSpin(true);

    http
      .get(`api/analyst?token=${token}`)
      .then((res) => {
        console.log("analyst ------->>>>", res.data);
        setAnalystinfo(res.data);
        // setFirstname(res.data.firstname);
        setLastname(res.data.lastname);
        setUploadSpin(false);
      })
      .catch((error) => {
        setUploadSpin(false);

        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              setError(error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            setError(error.response.data.message);
          }
        }
      });
  };

  const initialValues = {
    john: "",
    doe: "",
    johndoe: "",
    password: "",
    cellnumber: "",
    mailadress: "",
    achnumber: "",
    routingnumber: "",
    accountnumber: "",
    bankname: "",
  };
  // const validationSchema = Yup.object({
  //   john: Yup.string().required("required"),
  //   doe: Yup.string().required("required"),
  //   johndoe: Yup.string().required("required"),
  //   cellnumber: Yup.string().required("required"),
  //   mailadress: Yup.string().required("required"),
  //   password: Yup.string()
  //     .required("required")
  //     .min(6, "Password is too short - should be 8 chars minimum."),
  //   // .matches(/(?=.*[0-9])/, "Password must contain a number."),
  // });

   const validationSchema = Yup.object({
    firstname: Yup.string().required("First Name is required"),
    lastname: Yup.string().required("Last Name is required"),
    street_name_1: Yup.string().required("Street Name 1 is required"),
    street_name_2: Yup.string().required("Street Name 2 is required"),
    state: Yup.string().required("State is required"),
    city: Yup.string().required("City is required"),
    zipcode: Yup.string().required("Zipcode is required"),
    // achnumber: Yup.string().required("ACH Number is required"),
    routingnumber: Yup.string().required("Routing Number is required"),
    accountnumber: Yup.string().required("Account Number is required"),
    bankname: Yup.object().nullable().required("Bank name is required"),
   
  });
  const onSubmit = async (values) => {
    setUploadSpins(true);

    http
      .put(`api/analyst/edit?token=${token}`, {
        firstname: values.firstname,
        lastname: lastname,
        // achnumber: values.achnumber,
        routingnumber: values.routingnumber,
        accountnumber: values.accountnumber,
        bankname: values.bankname.value,
        // mailing_address: values.mailing_address,
        street_name_1: values.street_name_1,
        street_name_2: values.street_name_2,
        state: values.state,
        city: values.city,
        zipcode: values.zipcode
      })
      .then((res) => {
        console.log(" ------user info->>>>", res.data.message);
        showToast("success", res.data.message);
        imageUpload();
        userUpdate();
        setUploadSpins(false);
      })
      .catch((error) => {
        setUploadSpins(false);
        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              setError(error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            setError(error.response.data.message);
          }
        }
      });
  };
  const inputFileRef = useRef(null);
  const onBtnClick = () => {
    inputFileRef.current.click();
  };

  const fetchBankOptions = async () => {
    try {
      http
      .get(`api/analyst/bank-list?token=${token}`)
      .then((res) => {
        setBankOptions(res.data.data)
        const savedBank = res.data.data.find(bank => bank.value == analystinfo.bankname);
        setSelectedBank(savedBank);
      })
      .catch((error) => {
        setUploadSpin(false);

        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              setError(error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            setError(error.response.data.message);
          }
        }
      });
   }catch(error){
    console.log("e",error);
   }
  }

  useEffect(() => {
    if (user.data.image) {
      setPicture(user.data.image);
    }
    analyistInfo();
  }, []);

  useEffect(() => {
    if (analystinfo.bankname) {
      fetchBankOptions();
    }
  }, [analystinfo]);

  const [picture, setPicture] = useState(upload);
  const [photo, setPhoto] = useState(null);

  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      let img = event.target.files[0];
      setPhoto(img);
      const pictureToShow = URL.createObjectURL(img);
      setPicture(pictureToShow);
    }
  };

  const imageUpload = async () => {
    if (!photo) {
      return;
    }
    var formData = new FormData();

    formData.append("image", photo);
    console.log("image upload", photo);
    setUploadSpins(true);

    http
      .put(`api/analyst/profile-img?token=${token}`, formData)
      .then((res) => {
        console.log("response ------->>>>", res.data);
        setUploadSpins(false);
      })
      .catch((error) => {
        setUploadSpins(false);

        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              setError(error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            setError(error.response.data.message);
          }
        }
      });
  };

  const userUpdate = async (values) => {
    let user = localStorage.getItem("user");
    user = JSON.parse(user);
    console.log("personal info", values);
    setUploadSpins(true);

    http
      .get(`api/common/me?token=${token}`)
      .then((res) => {
        console.log("analyst ------->>>>", res.data);

        showToast("success", res.data.message);
        user.data = res.data;
        storage.store("user", user);
        imageUpload();
        setUploadSpins(false);
      })
      .catch((error) => {
        setUploadSpins(false);

        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              setError(error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            setError(error.response.data.message);
          }
        }
      });
  };

  return (
    <>
      {uploadSpin ? (
        <div
          style={{
            height: "100%",
            width: "100%",
            position: "absolute",
            marginTop: 150,
            backgroundColor: "#ffffffc2",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundBlendMode: "overlay",
            zIndex: 100,
          }}
        >
          <SpinnerCircular size="5%" />
        </div>
      ) : (
        <Formik 
          enableReinitialize 
          initialValues={{
            firstname: analystinfo.firstname,
            lastname: analystinfo.lastname,
            // achnumber: analystinfo.achnumber,
            bankname: selectedBank || null,
            accountnumber: analystinfo.accountnumber,
            routingnumber:analystinfo.routingnumber,
            // mailing_address:analystinfo.mailing_address,
            street_name_1:analystinfo.street_name_1,
            street_name_2:analystinfo.street_name_2,
            state:analystinfo.state,
            city:analystinfo.city,
            zipcode:analystinfo.zipcode
          }}
          // initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {({ values, handleChange, handleBlur, handleSubmit,setFieldValue  }) => (
            <>
              <header>
                <div className="custom_container ">
                  <HeaderLeft />
                  <div className="user_profile">
                    <DropdownRight />
                  </div>
                </div>
              </header>
              <section className="otp_verification">
                <div className="login_inner custom_hight">
                  <h1 className="mb_30 main_title ">Edit Profile</h1>

                  <div className="user_profile_eidte">
                    {" "}
                    {/*        <img src={users} alt="" />{" "}
              <img src={edit} className="user_edit_icon" alt="" /> */}
                    <input
                      type="file"
                      ref={inputFileRef}
                      onChange={onImageChange}
                      style={{ display: "none" }}
                    />
                    <img
                      alt="profile"
                      src={picture}
                      onClick={onBtnClick}
                      style={{
                        width: 150,
                        height: 150,
                        border: "1px solid gray",
                        padding: 5,
                        borderRadius: "50%",
                      }}
                    />
                  </div>
                  <div className="personal_and_bank_info">
                    <Tabs
                      style={{
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: 30,
                      }}
                      variant="pills"
                      defaultActiveKey="profile"
                      id="uncontrolled-tab-example"
                      className="mb-3"
                    >
                      <Tab
                        eventKey="home"
                        title=" Personal Info"
                        className="nav-item"
                      >
                        <div className="container">
                          <form
                            onSubmit={handleSubmit}
                            action="Welcome-personal-info_submit"
                            method="get"
                          >
                            <div className="row personal_info">
                              <div className="col-lg-4 col-md-6 col-sm-6">
                                <div className="form-group">
                                  <input
                                    type="text"
                                    onChange={handleChange("firstname")}
                                    onBlur={handleBlur("firstname")}
                                    value={values.firstname}
                                    className="form-control"
                                    placeholder="Joan"
                                  />{" "}
                                  <ErrorMessage component="div" className="text-danger" name="firstname" />
                                </div>
                              </div>
                              <div className="col-lg-4 col-md-6 col-sm-6">
                                <div className="form-group">
                                  <input
                                    type="text"
                                    className="form-control"
                                    onChange={handleChange("lastname")}
                                    onBlur={handleBlur("lastname")}
                                    value={values.lastname}
                                    placeholder="Doe"
                                  />{" "}
                                  <ErrorMessage component="div" className="text-danger" name="lastname" />
                                </div>
                              </div>
                              {/* <div className="col-12"></div> */}
                              <div className="col-lg-4 col-md-6 col-sm-6">
                                <div className="form-group">
                                  <input
                                    type="email"
                                    className="form-control"
                                    disabled
                                    value={analystinfo.email}
                                  />{" "}
                                </div>
                              </div>

                              <div className="col-lg-4 col-md-6 col-sm-6">
                                <div className="form-group">
                                  <input
                                    type="text"
                                    className="form-control"
                                    disabled
                                    value={analystinfo.phone}
                                  />{" "}
                                </div>
                              </div>

                              {/* <div className="col-lg-4 col-md-6 col-sm-6">
                                <div className="form-group">
                                  <input
                                    type="text"
                                    className="form-control"
                                    onChange={handleChange("mailing_address")}
                                    onBlur={handleBlur("mailing_address")}
                                    value={values.mailing_address}
                                    placeholder="Mailing Address"
                                  />{" "}
                                </div>
                              </div> */}

                              <div className="col-lg-4 col-md-6 col-sm-6">
                                <div className="form-group">
                                  <input
                                    type="text"
                                    className="form-control"
                                    onChange={handleChange("street_name_1")}
                                    onBlur={handleBlur("street_name_1")}
                                    value={values.street_name_1}
                                    placeholder="Street Name 1"
                                  />{" "}
                                  <ErrorMessage component="div" className="text-danger" name="street_name_1" />
                                </div>
                              </div>

                              <div className="col-lg-4 col-md-6 col-sm-6">
                                <div className="form-group">
                                  <input
                                    type="text"
                                    className="form-control"
                                    onChange={handleChange("street_name_2")}
                                    onBlur={handleBlur("street_name_2")}
                                    value={values.street_name_2}
                                    placeholder="Street Name 2"
                                  />{" "}
                                  <ErrorMessage component="div" className="text-danger" name="street_name_2" />
                                </div>
                              </div>

                              <div className="col-lg-4 col-md-6 col-sm-6">
                                <div className="form-group">
                                  <input
                                    type="text"
                                    className="form-control"
                                    onChange={handleChange("state")}
                                    onBlur={handleBlur("state")}
                                    value={values.state}
                                    placeholder="State"
                                  />{" "}
                                  <ErrorMessage component="div" className="text-danger" name="state" />
                                </div>
                              </div>

                              <div className="col-lg-4 col-md-6 col-sm-6">
                                <div className="form-group">
                                  <input
                                    type="text"
                                    className="form-control"
                                    onChange={handleChange("city")}
                                    onBlur={handleBlur("city")}
                                    value={values.city}
                                    placeholder="city"
                                  />{" "}
                                  <ErrorMessage component="div" className="text-danger" name="city" />
                                </div>
                              </div>

                              <div className="col-lg-4 col-md-6 col-sm-6">
                                <div className="form-group">
                                  <input
                                    type="text"
                                    className="form-control"
                                    onChange={handleChange("zipcode")}
                                    onBlur={handleBlur("zipcode")}
                                    value={values.zipcode}
                                    placeholder="zipcode"
                                  />{" "}
                                  <ErrorMessage component="div" className="text-danger" name="zipcode" />
                                </div>
                              </div>
                            </div>
                            <div className="btn_wraper">
                              <button
                                type="submit"
                                className="them_btn mt_40 mb_30"
                              >
                                {uploadSpins ? (
                                  <SpinnerCircular className="button-spin" />
                                ) : (
                                  "  Save Changes"
                                )}
                              </button>
                            </div>
                          </form>
                        </div>
                      </Tab>

                      <Tab eventKey="profile" title=" Bank Details">
                        <div className="container  ">
                          <div className="col-lg-8 mx-auto">
                            <form>
                              <div className="row personal_info">

                                {/* <div className="col-lg-6 col-md-6 col-sm-6">
                                  <div className="form-group">
                                    <input
                                      type="text"
                                      onChange={handleChange("achnumber")}
                                      onBlur={handleBlur("achnumber")}
                                      value={values.achnumber}
                                      className="form-control"
                                      placeholder="ACH Number"
                                    />{" "}
                                    <ErrorMessage component="div" className="text-danger" name="achnumber" />
                                  </div>
                                </div> */}

                                 <div className="col-lg-6 col-md-6 col-sm-6">
                                 <div className="form-group">
                                    <input
                                      type="text"
                                      onChange={handleChange("routingnumber")}
                                      onBlur={handleBlur("routingnumber")}
                                      value={values.routingnumber}
                                      className="form-control"
                                      placeholder="Routing Number"
                                    />{" "}
                                    <ErrorMessage component="div" className="text-danger" name="routingnumber" />
                                  </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-6">
                                  <div className="form-group">
                                    <input
                                      type="test"
                                      onChange={handleChange("accountnumber")}
                                      onBlur={handleBlur("accountnumber")}
                                      value={values.accountnumber}
                                      className="form-control"
                                      placeholder="Account Number"
                                    />{" "}
                                    <ErrorMessage component="div" className="text-danger" name="accountnumber" />
                                  </div>
                                </div>
                                <div className="col-12">
                                  <div className="form-group">

                                    {/* <input
                                      type="test"
                                      onChange={handleChange("bankname")}
                                      onBlur={handleBlur("bankname")}
                                      value={values.bankname}
                                      className="form-control"
                                      placeholder="Bank Name"
                                    />{" "} */}

                                    <Select
                                      options={bankOptions}
                                      onChange={(option) => {
                                        setSelectedBank(option);
                                        setFieldValue("bankname", option);
                                      }}
                                      onBlur={handleBlur("bankname")}
                                      value={values.bankname}
                                      placeholder="Select Bank"
                                      isSearchable
                                      styles={{
                                        control: (base) => ({
                                          ...base,
                                          height: '60px',
                                          // minHeight: '60px',
                                          padding: '5px'
                                        })
                                      }}
                                    />

                                    <ErrorMessage component="div" className="text-danger" name="bankname" />
                                  </div>
                                </div>
                              </div>
                              <div className="btn_wraper">
                                <button
                                  type="submit"
                                  className="them_btn mt_40 mb_30"
                                  onClick={handleSubmit}
                                >
                                  {uploadSpins ? (
                                    <SpinnerCircular className="button-spin" />
                                  ) : (
                                    "  Save Changes"
                                  )}
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                      </Tab>
                    </Tabs>
                  </div>
                </div>
              </section>
              <ToastContainer />
            </>
          )}
        </Formik>
      )}
    </>
  );
}

export default EditProfile;
